<template>
    <div>
        <div class="modal-overlay active"  @click="closeDialog()"></div>
            <div class="modal">
                <div class="modal__header">
                    <h2
                        id="createListModalTitle"
                        class="headline-s"
                    >
                        Create List
                    </h2>
                    <CloseIcon @click="closeDialog()" class="modal__header--close" alt="Close Modal" aria-label="Close" />
                </div>
            <div class="modal__body flex-column" id="createListModalBody">
                <div class="input-folder">
                    <div class="input-folder--input">
                        <PrimeInputText type="text" id="renameInput" v-model="nameInput" placeholder=" " required />
                        <label for="renameInput">
                            <p class="paragraph-default">New List Name *</p>
                        </label>
                    </div>
                </div>

                <div class="modal__footer flex-row justify-end">
                    <RothcoCta id="submitButton" :class="formValid ? `primary` : `disabled`" @click="submit">Start List</RothcoCta>
                </div>
            </div>
    </div>
</div>
</template>
<script lang="ts" setup>
    import { ref, computed, inject } from "vue";
    import { router } from "@inertiajs/vue3";
    import { useLists } from "@/helpers/composables/useList";
    import RothcoCta from "@/components/RothcoCta.vue";
    import CloseIcon from "@icons/closeIcon.svg";

    let dialogRef = inject('dialogRef');
    let route = inject('route');
    let { createList } = useLists({ router, route });

    let modelValue = defineModel();
    let nameInput = ref("");


    let makeCurrent = computed(()=>{
        return dialogRef?.value?.data?.make_current;
    })

    let afterFetch = computed(()=>{
        let defaultAfterFetch = () => {};
        return dialogRef?.value?.data?.afterFetch ?? defaultAfterFetch;
    })
    const formValid = computed(() => {
        return nameInput.value != null && nameInput.value != "";
    });
    const closeDialog = function () {
        dialogRef?.value?.close();
    };
    const submit = function () {
        let newList = {
            list_name: nameInput.value,
            make_current: makeCurrent.value ? 1 : 0
        };
        createList(newList, {
            afterFetch: () => {
                setTimeout(() => {
                    closeDialog();
                }, 500);
                return afterFetch.value( );
            }
        });
    };
</script>
